import client from './client';

export const get = () => client({
	method: 'get',
	url: '/telemedicine'
});
